const V = {
  name: "FaroeIslands",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 0V2.5L17 5.5V9H16V13H17V15H16V18.5858L18 20.5858V24H6V20.5858L8 18.5858V15H7V13H8V9H7V5.5L11 2.5V0H13ZM10 12V13H14V12H10ZM14 10V9H10V10H14ZM15 7V6.5L12 4.25L9 6.5V7H15ZM10 19.4142L8 21.4142V22H16V21.4142L14 19.4142V15H10V19.4142Z" fill="currentColor"/>
</svg>
  `
};
export {
  V as FaroeIslands
};
